<template>
  <!-- :class="navBarActive == '/'?'Box':''" -->
  <el-header id="hearderapp" height="80px">
    <div class="row-bg">
      <div>
        <span
          @click="toIndex"
          class="newlogoSpan"
          :style="{ backgroundImage: 'url(' + logo + ')' }"
        ></span>
      </div>
      <div>
        <el-menu
          :default-active="activeMenu()"
          class="el-menu-demo headerjianj"
          mode="horizontal"
          @select="handleSelect"
          router
        >
          <el-menu-item
            index="/"
            :class="activeIndex === 0 ? 'is-select' : ''"
            @click="handleClick('/')"
            >首页</el-menu-item
          >
          <el-menu-item
            @click="handleClick('/ProjectSquare')"
            index="/ProjectSquare"
            :class="activeIndex == 1 ? 'is-select' : ''"
            >项目广场</el-menu-item
          >

          <el-menu-item @click="toKepler()"> Kepler PAP </el-menu-item>
          <el-menu-item @click="toAI()"> Kepler AI </el-menu-item>
          <el-menu-item @click="toTAO()"> 淘软件 </el-menu-item>
          <el-menu-item
            index="/classUtils"
            :class="activeIndex == 5 ? 'is-select' : ''"
            @click="handleClick('/classUtils')"
            >课程中心</el-menu-item
          >
          <el-menu-item
            index="/purchaseMembership"
            :class="activeIndex == 6 ? 'is-select' : ''"
            @click="handleClick('/purchaseMembership')"
            >定价</el-menu-item
          >
          <el-menu-item
            index="/CustomerCase"
            :class="activeIndex == 7 ? 'is-select' : ''"
            @click="handleClick('/CustomerCase')"
            >客户案例</el-menu-item
          >
          <el-menu-item
            index="/showRules.html/01/011"
            :class="activeIndex == 8 ? 'is-select' : ''"
            @click="handleClick('/showRules.html/01/011')"
            >工厂规则</el-menu-item
          >
          <el-menu-item
            index="/help"
            :class="activeIndex == 9 ? 'is-select' : ''"
            @click="handleClick('/help')"
            >帮助中心</el-menu-item
          >
          <el-menu-item
            index="/AboutUs"
            :class="activeIndex == 10 ? 'is-select' : ''"
            @click="handleClick('/AboutUs')"
            >关于我们</el-menu-item
          >
          <!-- <el-menu-item class="rightMode" index="/quicklyReleaseRequirements.html">快速发布需求</el-menu-item> -->
        </el-menu>
      </div>
      <div class="rightMode" v-if="Whether">
        <el-button
          v-if="currentIdentity.length > 0 && Number(level) >= 1"
          type="text"
          icon="el-icon-refresh"
          size="mini"
          round
          @click="choiceid"
          style="color: #2f80ed; font-size: 16px"
          >{{ textName }}</el-button
        >
        <div class="tonzhi"><img src="../../assets/image/tonzhi.png" /></div>
        <!--        <el-button style="margin-right: 12px;color:#f9bd00" type="text" @click="handlePurchase"-->
        <!--        >购买会员</el-button>-->
        <el-dropdown trigger="hover">
          <span class="el-dropdown-link">
            <img
              class="avatar"
              :src="Headportrait"
              width="40px"
              height="40px"
            />
            <img
              v-if="Number(level) > 0"
              class="vip"
              :src="vipImg"
              height="16px"
            />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <div class="validity" v-if="level >= 1 && levelEnd">
                有效期至：{{ levelEnd ? levelEnd : "2199-12-30" }}
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="Personalcenter()">个人中心</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="Logout()">退出登录</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-else class="logzc">
        <el-button class="logdlbtn" type="primary" plain @click="tabchuyg"
          >登录</el-button
        >
        <el-button class="logzcbtn" type="primary" @click="tanchu = !tanchu"
          >免费注册</el-button
        >
      </div>
    </div>
    <!-- 注册弹窗 -->
    <div class="auibsu" v-if="tanchu">
      <tancyg
        :tanchu="tanchu"
        @changeComponent1Data="component1DataChange"
      ></tancyg>
    </div>
    <!-- 登录框-->
    <el-dialog
      width="424px"
      class="newloginWrapper"
      :visible.sync="modelShow"
      :lock-scroll="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
    >
      <denlyx ref="mychild" @immediatelyData="immediatelyData"></denlyx>
    </el-dialog>
  </el-header>
</template>

<script>
import lunbot from "@/components/Lunbot/lunbot";
import tancyg from "@/components/user/registered";
import denlyx from "@/components/denlu/zhesdengl";
import { keplerUrl } from "@/api/common";
import { setToken, removeToken, getToken } from "@/utils/auth";
import { Logoutanmin, Accesstoimage } from "@/api/projectSquare/xmgc";
import { getUserTypeInfo } from "@/api/public/editphone";

import { setSelectType } from "@/api/projectSquare/xmgc";
export default {
  name: "index",
  components: {
    lunbot: lunbot,
    tancyg: tancyg,
    denlyx: denlyx,
  },
  data() {
    return {
      level: sessionStorage.getItem("level"),
      levelEnd: "",
      downloadUrl: "https://www.isoftfactory.com/gcapi",
      // downloadUrl:'http://192.168.8.17:32007',
      vipImg: "",
      acceptIndex: "",
      kepler: "http://36.158.225.130:9880/",
      taorj: "http://taorj.isoftfactory.com/",
      logo: require("../../assets/logo2.png"),
      activeIndex: 0,
      isActive: "is-active",
      tanchu: 0,
      //是否显示本面板
      modelShow: false,
      // 获取头像
      Headportrait: "",
      // 是否获取到头像
      Headportadd: "",
      // 获取登录后的ID
      userId: "",
      // 判断是否登录
      Whether: "",
      // 判断身份
      usertypeasd: "",
      isAcceptTz: true,
      navBarActive: null,
      currentIdentity: [], // 所有身份
      lodingType: null, // 当前身份
      projTypeArr: [],
      textName: "", // 切换身份文字
      menuIndexMap: {
        "/": 0,
        "/ProjectSquare": 1,
        "/classUtils": 5,
        "/purchaseMembership": 6,
        "/CustomerCase": 7,
        "/showRules.html/01/011": 8,
        "/help": 9,
        "/AboutUs": 10,
      },
    };
  },
  created() {
    this.Whetherthelogin();
  },
  mounted() {
    keplerUrl().then((res) => {
      this.kepler = res.keplerAddress;
      this.taorj = res.taoRJAddress;
    });
  },
  watch: {
    "$route.path": {
      handler(newPath) {
        if (newPath == "/classUtils/classItems") {
          this.activeIndex = 5;
        } else if (!this.menuIndexMap.hasOwnProperty(newPath)) {
          this.activeIndex = "";
        } else {
          this.activeIndex = this.menuIndexMap[newPath];
        }
      },
    },
  },
  methods: {
    handleClick(path) {
      this.$router.push(path);
    },
    handlePurchase() {
      this.$router.push("/purchaseMembership");
    },
    toKepler() {
      if (this.Whether) {
        window.open(
          this.kepler + "workspace/#/plant?token=" + getToken() + "&apltId="
        );
        console.log("123token=", getToken());

        // this.toIndex();
      } else {
        // window.open(this.kepler); // 跳转到kepler首页
        this.$message({
          message: "请先登录后再访问Kepler PAP",
          type: "warning",
        });
        this.tabchuyg(); // 登录
        sessionStorage.setItem(
          "redirectPath",
          this.kepler + "workspace/#/plant?token=" + getToken() + "&apltId="
        );
      }
    },
    toTAO() {
      if (this.Whether) {
        window.open(this.taorj + "?token=" + getToken());
        // this.toIndex();
      } else {
        window.open(this.taorj);
        // this.toIndex();
      }
    },
    // 判断个人中心身份
    Personalcenter() {
      if (this.lodingType == 1) {
        // 接包方
        this.acceptIndex = "/acpUser/acpMessagecenter/Themessagecenter";
        this.$router.push("/acpUser/acpUserBaseInfo/acpUserIndex");
      } else if (this.lodingType == 2) {
        // 发包方
        this.acceptIndex = "/empUser/empMessagecenter/Themessagecentertwo";
        this.isAcceptTz = false;
        this.$router.push("/empUser/empCa/accountIndex");
      } else {
        // 选择身份
        this.acceptIndex = "/Selectthe.html";
        this.$router.push("/Selectthe.html");
      }
    },
    // log返回首页
    indexqu() {
      // location.href = '/';

      this.$router.go("/");
    },
    // 退出登录
    Logout() {
      removeToken();
      //this.$router.replace("/ProjectSquare");
      location.href = "/";
      this.activeIndex = 0;
      localStorage.removeItem("userId");
      sessionStorage.removeItem("Headportrait");
      sessionStorage.removeItem("usertype");
      sessionStorage.removeItem("Mobilephone");
      sessionStorage.removeItem("level");
      sessionStorage.removeItem("redirectPath");
      // 退出登录接口
      Logoutanmin()
        .then((response) => {})
        .catch((response) => {});
    },
    // 这里回去登录注册传过来的值，做判断点击的是忘记密码(0)，还是立即注册(1)
    immediatelyData(artlf, isd, usertype) {
      // alert(artlf)
      // 赋值个人中心
      //第一次登录的 isd 子传父 判断是否登录状态
      // 接口取值当登录的时候获取头像
      Accesstoimage()
        .then((response) => {
          if (response.data.code === 200) {
            if (response.data.audit && response.data.audit == 1) {
              this.Whether = false;
            } else {
              this.usertypeasd = sessionStorage.getItem("usertype");
              this.Whether = true;
              this.getIduserInfo(); // 获取用户身份信息
              // this.Headportrait = sessionStorage.getItem("Headportrait");
              // 从接口取头像
              Accesstoimage()
                .then((response) => {
                  this.Headportrait = this.ifimgsrc(
                    response.headStatus,
                    response.headportrait,
                    response.loginType
                  );
                  this.vipImg = response.sign
                    ? this.downloadUrl + response.sign
                    : "";
                  if (response.levelEnd) {
                    this.levelEnd = response.levelEnd.substring(0, 10);
                  }
                  sessionStorage.setItem("level", response.levelSign);
                  this.level = response.levelSign;
                  sessionStorage.setItem("vipImg", this.vipImg);
                  sessionStorage.setItem("endTime", this.levelEnd);
                })
                .catch((response) => {});
            }
          } else {
            this.Whether = false;
          }
        })
        .catch((response) => {});

      // 判断登录界面的操作
      if (artlf === "0") {
        this.tanchu = 1;
        this.modelShow = false;
      } else if (artlf === "1") {
        this.modelShow = false;
      } else if (artlf === "2") {
        this.modelShow = false;
      }
    },
    // 当页面刷新时候的判断是否登录
    Whetherthelogin() {
      // 个人中心类型
      // if (this.currentIdentity[0] == "1") {
      //   this.acceptIndex = "/acpUser/acpMessagecenter/Themessagecenter";
      // } else if (this.currentIdentity[0] == "2") {
      //   this.acceptIndex = "/empUser/empMessagecenter/Themessagecentertwo";
      // } else {
      //   this.acceptIndex = "/Selectthe.html";
      // }
      // this.userId = localStorage.getItem("userId");
      // 从接口取值判断是否登录与获取头像
      Accesstoimage()
        .then((response) => {
          if (response.code === 200) {
            this.Whether = true;
            this.getIduserInfo(); // 获取用户身份信息
            // this.Headportrait = sessionStorage.getItem("Headportrait");
            // 从接口取头像
            Accesstoimage()
              .then((response) => {
                // this.Headportrait = response.headportrait;
                this.Headportrait = this.ifimgsrc(
                  response.headStatus,
                  response.headportrait,
                  response.loginType
                );

                this.vipImg = response.sign
                  ? this.downloadUrl + response.sign
                  : ""; // 接包方使用头像
                if (response.levelEnd) {
                  this.levelEnd = response.levelEnd.substring(0, 10);
                }
                sessionStorage.setItem("vipImg", this.vipImg);
                sessionStorage.setItem("level", response.levelSign);
                this.level = response.levelSign;
                sessionStorage.setItem("endTime", this.levelEnd);
                this.usertypeasd = response.type;
                if (response.headportrait != null) {
                  this.Headportadd = true;
                } else {
                  this.Headportadd = false;
                }
              })
              .catch((response) => {});
          } else {
            this.Whether = false;
          }
        })
        .catch((response) => {});
    },

    // 判断返回当前图片 type // 类型1：上传了头像  2：男  3：女  4：默认
    // src // 图片地址
    // idp // 当前身份
    ifimgsrc(type, src, idp) {
      let imgsrc = "";
      if (type == 1) {
        imgsrc = src; // 接包方使用头像
      } else if (type == 2) {
        if (idp == 1) {
          imgsrc = require("../../assets/image/newjiebao.png"); // 接包方使用头像
        } else {
          imgsrc = require("../../assets/image/newfabao.png"); // 发包方使用头像
        }
      } else if (type == 3) {
        if (idp == 1) {
          imgsrc = require("../../assets/image/newjiebaonv.png"); // 接包方使用头像
        } else {
          imgsrc = require("../../assets/image/newfabaonv.png"); // 发包方使用头像
        }
      } else if (type == 4) {
        if (idp == 1) {
          imgsrc = require("../../assets/image/newjiebaowu.png"); // 接包方使用头像
        } else {
          imgsrc = require("../../assets/image/newfabaowu.png"); // 发包方使用头像
        }
      }
      return imgsrc;
    },

    tabchuyg() {
      this.modelShow = true;
      // 调用子组件生成二维码的方法
      this.$nextTick(() => {
        this.$refs.mychild.creatQrCode();
      });
    },
    handleSelect(index) {
      // 通过映射表获取索引
      if (!index) return;
      // this.activeIndex = this.menuIndexMap[index];
    },
    component1DataChange(params) {
      if (params === 0) {
        this.tanchu = 0;
      } else {
        this.tanchu = 0;
        this.modelShow = true;
      }
    },
    activeMenu() {
      const arr = [{ key: "Detailsonthesquare", with: "/ProjectSquare" }];
      for (let i = 0; i < arr.length; i++) {
        if (this.$route.path.indexOf(arr[i].key) > -1) return arr[i].with;
      }
      this.navBarActive = this.$route.path;
      return this.$route.path;
    },
    toIndex() {
      this.$router.push("/");
      setTimeout(() => {
        this.activeIndex = 0; // 延迟更新，让首页生效
      }, 100);
    },
    toAbout() {
      this.$router.go("/AboutUs");
    },

    // 用户选择接包方或者发包方是的点击事件
    choiceid() {
      let typeone = this.lodingType == 1 ? 2 : 1;
      // 当前是接包方则跳发包方个人中心
      setSelectType(typeone)
        .then((respones) => {
          removeToken(); // 清除已有的 token
          setToken(respones.data); // 设置 token
          if (this.lodingType == 1) {
            // 去发包方个人中心
            location.href = "/empUser/empCa/accountIndex";
          } else if (this.lodingType == 2) {
            // 去接包方个人中心
            location.href = "/acpUser/acpUserBaseInfo/acpUserIndex";
          }
        })
        .catch((respones) => {});
    },

    // 获取用户身份信息
    getIduserInfo() {
      getUserTypeInfo()
        .then((res) => {
          this.currentIdentity = res.data.userTypes;
          this.lodingType = res.data.loginType;
          console.log(this.currentIdentity.length, "================");

          if (res.data.loginType == 1) {
            this.textName = "发包方中心";
          } else if (res.data.loginType == 2) {
            this.textName = "接包方中心";
          }
        })
        .catch((res) => {});
    },

    toAI() {
      if (this.Whether) {
        window.open("/AI");
        // this.toIndex();
      } else {
        this.tabchuyg(); // 登录
        sessionStorage.setItem("redirectPath", "/AI");
      }
    },
  },
};
</script>

<style scoped>
/* 当前页面的最外部div 12-02 */
/* .Box{
    filter:progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
    -webkit-filter: grayscale(100%);
  } */

#hearderapp {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 99;
  padding: 0;
}

.row-bg {
  width: 100%;
  padding: 0 7%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.newlogoSpan {
  width: 217px;
  height: 41px;
  display: inline-block;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.el-menu--horizontal > .el-menu-item {
  font-size: 16px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.9);
  padding: 0;
  padding-left: 20px;
  height: 80px;
  line-height: 80px;
  border: none;
}

.el-menu--horizontal > .el-menu-item.is-active {
  background-color: transparent !important;
  color: black !important;
}

.el-menu--horizontal > .el-menu-item.is-select {
  border: none;
  color: black;
  font-weight: bold;
}

.headerjianj {
  margin-left: 20px;
}

.logzc,
.rightMode {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.el-menu::after,
.el-menu::before {
  display: none;
  content: "";
}

.el-dropdown-link {
  position: relative;
}

.avatar {
  border-radius: 50%;
  /*border: 1px solid #2f80ed;*/
}

.vip {
  position: absolute;
  right: -2px;
  bottom: 2px;
}

.tonzhi {
  margin-right: 12px;
}

.el-dropdown-link img {
  border-radius: 50%;
}

.tonzhi {
  margin-right: 30px;
}

li {
  font-family: PingFang-SC-Regular, PingFang-SC;
}

.logzcbtn {
  box-shadow: 0px 4px 10px 0px rgb(00 29 46 / 30%);
  margin-left: 30px;
}

.logzcbtn:hover {
  background: #2a75d9;
  border-color: #2a75d9;
}

.logdlbtn {
  background: #fff;
  border-color: #2f80ed;
}

.logdlbtn:hover {
  background: #e0edff;
  border-color: #2f80ed;
  color: #2f80ed;
}

.validity {
  margin: 0 10px;
  font-size: 12px;
  line-height: 30px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 15px;
  color: #aaa;
  background-color: #fff2e8;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  width: auto;
}

/deep/ .el-dropdown-menu__item {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/head/index.vue